module.exports = __webpack_public_path__ + "img/LTC.c221da92.png";